import type { TextFieldProps } from "../../../components/form/TextField";
import TextField from "../../../components/form/TextField";
import type { TitleBlock } from "../../schema/blocks/title";

type TitleOptionsProps = {
    block: TitleBlock;
    onChange: (block: TitleBlock) => void;
};

export default function TitleOptions(props: TitleOptionsProps) {
    const { block, onChange } = props;
    const anchorField: TextFieldProps = {
        label: "Ancre",
        value: block.anchor,
        onChange: (anchor) => onChange({ ...block, anchor: anchor ?? null }),
    };
    return <TextField {...anchorField} />;
}
